<template>
  <div class="section">
    <div class="box">
      <div class="row" id="main-row" v-if="!isLoading">
        <div id="vapp">
          <div class="">
            <b-button @click="goBack" type="is-success">
              <h3><b-icon icon="arrow-left" size="is-small"></b-icon> Go back</h3>
            </b-button>
          </div>
          <div class="header">
            <h1>{{ this.moduleDetails.module_name }}</h1>
          </div>

          <b-tabs v-model="activeTab">
            <b-tab-item label="Details">
              <b-field label="Name">
                <b-input v-model="moduleDetails.module_name"></b-input>
              </b-field>
              <b-field label="Formatted Name">
                <b-input v-model="moduleDetails.formatted_name"></b-input>
              </b-field>
              <b-field label="Description">
                <b-input v-model="moduleDetails.description"></b-input>
              </b-field>
              <b-field label="Context Name">
                <b-input v-model="moduleDetails.context_name"></b-input>
              </b-field>
              <b-button type="is-success" @click="updateModule">Save</b-button>
            </b-tab-item>

            <b-tab-item label="Outputs">
              <b-field :label="'Output: ' + (index + 1)" label-position="on-border" v-for="(output, index) in outputs" :key="output.id">
                <b-input v-model="output.name"></b-input>
                <b-button @click="deleteOutput(output.id)" type="is-danger" icon-right="trash"></b-button>
                <b-button @click="saveOutput(output)" type="is-success" icon-right="save"></b-button>
              </b-field>
              <b-button type="is-warning" @click="isNewOutputActive = true">New Output</b-button>
            </b-tab-item>

            <b-tab-item label="Text to speech">
              <div class="level">
                <!-- Left side -->
                <div class="level-left">
                  <div class="level-item">
                    <p class="subtitle is-5"><strong>TTS</strong></p>
                  </div>
                </div>

                <div class="level-right">
                  <div class="level-item">
                    <b-button type="is-warning" @click="isNewTTSActive = true">New TTS</b-button>
                    <b-field grouped label="Presets" label-position="on-border">
                      <b-select v-model="selectedPreset" @input="UpdatePreset(selectedPreset)">
                        <option v-for="preset in presets" :value="preset.id" :key="preset.id">
                          {{ preset.name }}
                        </option>
                      </b-select>
                    </b-field>
                  </div>
                </div>
              </div>
              <b-tabs v-model="activeTabTTS">
                <b-tab-item :label="ttsObj.name + ': ' + ttsObj.code" v-for="ttsObj in this.ttsArray" :key="ttsObj.language_id">
                  <b-table :data="ttsObj.ttsContent" v-if="selectedPreset == -1">
                    <b-table-column v-slot="props" label="Names">
                      <b-field label="Var name" expanded label-position="on-border">
                        <b-input v-model="props.row.tag" label-position="on-border" disabled></b-input>
                      </b-field>
                      <b-field label="Pretty Name" expanded label-position="on-border">
                        <b-input v-model="props.row.formatted_name" placeholder="Formatted Name" label-position="on-border"></b-input>
                      </b-field>
                    </b-table-column>
                    <b-table-column v-slot="props" label="Value">
                      <b-input type="textarea" v-model="props.row.content" placeholder="Default setting value" expanded></b-input>
                    </b-table-column>
                    <b-table-column v-slot="props" label="Description">
                      <b-input type="textarea" v-model="props.row.description" placeholder="Description" label-position="on-border"></b-input>
                    </b-table-column>
                    <b-table-column v-slot="props" label="Beep" width="50">
                      <b-checkbox v-model="props.row.beep"></b-checkbox>
                    </b-table-column>
                    <b-table-column v-slot="props" label="Hide" width="50">
                      <b-checkbox v-model="props.row.hidden" true-value="1" false-value="0"></b-checkbox>
                    </b-table-column>
                    <b-table-column field="actions" label="Actions" v-slot="props" width="50">
                      <b-tooltip label="Save" position="is-top">
                        <b-button @click="saveTTS(props.row)" type="is-success" icon-right="save"></b-button>
                      </b-tooltip>
                      <b-tooltip label="Conditions" position="is-left">
                        <b-button @click="OpenConditionsModal(props.row, 'tts')" type="is-success" icon-right="code"> </b-button>
                      </b-tooltip>
                      <b-tooltip label="Delete TTS" position="is-bottom">
                        <b-button @click="deleteTTS(props.row.tts_id)" type="is-danger" icon-right="trash"> </b-button>
                      </b-tooltip>
                    </b-table-column>
                  </b-table>

                  <b-table :data="ttsObj.ttsContent" v-else>
                    <b-table-column v-slot="props" label="Names">
                      <b-field label="Var name" expanded label-position="on-border">
                        <b-input v-model="props.row.tag" label-position="on-border" disabled></b-input>
                      </b-field>
                      <b-field label="Pretty Name" expanded label-position="on-border">
                        <b-input v-model="props.row.formatted_name" placeholder="Formatted Name" label-position="on-border" disabled></b-input>
                      </b-field>
                    </b-table-column>
                    <b-table-column v-slot="props" label="Value">
                      <b-input
                        v-if="selectedPresetTTS[props.row.tts_id].is_default"
                        v-model="selectedPresetTTS[props.row.tts_id].default_value"
                        :disabled="selectedPresetTTS[props.row.tts_id].is_default"
                        expanded
                      ></b-input>
                      <b-input
                        v-else
                        v-model="selectedPresetTTS[props.row.tts_id].tts_value"
                        :disabled="selectedPresetTTS[props.row.tts_id].is_default"
                        placeholder="Preset tts value"
                        expanded
                      ></b-input>
                    </b-table-column>
                    <b-table-column v-slot="props" label="Use Default">
                      <b-checkbox v-model="selectedPresetTTS[props.row.tts_id].is_default"></b-checkbox>
                    </b-table-column>
                    <b-table-column field="actions" label="Actions" v-slot="props" width="50">
                      <b-tooltip label="Save" position="is-top">
                        <b-button @click="savePresetTTS(selectedPresetTTS[props.row.tts_id])" type="is-success" icon-right="save"></b-button>
                      </b-tooltip>
                    </b-table-column>
                  </b-table>
                </b-tab-item>
              </b-tabs>
            </b-tab-item>

            <b-tab-item label="Settings">
              <div class="level">
                <!-- Left side -->
                <div class="level-left">
                  <div class="level-item">
                    <p class="subtitle is-5"><strong>Settings</strong> - The save button is now at the bottom :)</p>
                  </div>
                </div>

                <div class="level-right">
                  <div class="level-item">
                    <b-button type="is-warning" @click="isNewSettingActive = true">New Setting</b-button>
                    <b-field grouped label="Presets" label-position="on-border">
                      <b-select v-model="selectedPreset" @input="UpdatePreset(selectedPreset)">
                        <option v-for="preset in presets" :value="preset.id" :key="preset.id">
                          {{ preset.name }}
                        </option>
                      </b-select>
                    </b-field>
                  </div>
                </div>
              </div>
              <b-table :data="settings" v-if="selectedPreset == -1">
                <b-table-column v-slot="props" label="Names">
                  <b-field label="Var name" expanded label-position="on-border">
                    <b-input v-model="props.row.settings_name" label-position="on-border" disabled></b-input>
                  </b-field>
                  <b-field label="Pretty Name" expanded label-position="on-border">
                    <b-input v-model="props.row.formatted_name" placeholder="Formatted Name" label-position="on-border"></b-input>
                  </b-field>
                </b-table-column>
                <b-table-column v-slot="props" label="Value">
                  <b-input v-model="props.row.settings_value" placeholder="Default setting value" expanded></b-input>
                </b-table-column>
                <b-table-column v-slot="props" label="Description">
                  <b-input type="textarea" v-model="props.row.description" placeholder="Description" label-position="on-border"></b-input>
                </b-table-column>
                <b-table-column v-slot="props" label="Hide" width="50">
                  <b-checkbox v-model="props.row.hidden" true-value="1" false-value="0"></b-checkbox>
                </b-table-column>
                <b-table-column v-slot="props" label="Type" width="150">
                  <b-select placeholder="Type" v-model="props.row.settings_type_id" label="Display order">
                    <option v-for="settingsType in settingsTypes" :value="settingsType.id" :key="settingsType.id">
                      {{ settingsType.type }}
                    </option>
                  </b-select>
                </b-table-column>
                <b-table-column v-slot="props" width="50">
                  <b-tooltip label="Conditions" position="is-top">
                    <b-button @click="OpenConditionsModal(props.row, 'setting')" type="is-success" icon-right="code"> </b-button>
                  </b-tooltip>
                  <b-tooltip label="Delete Setting" position="is-bottom">
                    <b-button @click="deleteSetting(props.row.settings_id)" type="is-danger" icon-right="trash"> </b-button>
                  </b-tooltip>
                </b-table-column>
              </b-table>
              <b-table :data="settings" v-else>
                <b-table-column v-slot="props" label="Names">
                  <b-field label="Var name" expanded label-position="on-border">
                    <b-input v-model="props.row.settings_name" label-position="on-border" disabled></b-input>
                  </b-field>
                  <b-field label="Pretty Name" expanded label-position="on-border">
                    <b-input v-model="props.row.formatted_name" placeholder="Formatted Name" label-position="on-border" disabled></b-input>
                  </b-field>
                </b-table-column>
                <b-table-column v-slot="props" label="Value">
                  <b-input
                    v-if="selectedPresetSettings[props.row.settings_id].is_default"
                    v-model="selectedPresetSettings[props.row.settings_id].default_value"
                    :disabled="selectedPresetSettings[props.row.settings_id].is_default"
                    expanded
                  ></b-input>
                  <b-input
                    v-else
                    v-model="selectedPresetSettings[props.row.settings_id].setting_value"
                    :disabled="selectedPresetSettings[props.row.settings_id].is_default"
                    placeholder="Preset setting value"
                    expanded
                  ></b-input>
                </b-table-column>
                <b-table-column v-slot="props" label="Value">
                  <b-checkbox v-model="selectedPresetSettings[props.row.settings_id].is_default">Use Default</b-checkbox>
                </b-table-column>
                <b-table-column v-slot="props" label="Actions">
                  <b-button @click="savePresetSetting(selectedPresetSettings[props.row.settings_id])" type="is-success" icon-right="save"></b-button>
                </b-table-column>
              </b-table>

              <b-button type="is-success" @click="SaveSettings">Save</b-button>
            </b-tab-item>

            <b-tab-item label="Presets">
              <b-table
                :data="
                  presets.filter((preset) => {
                    return preset.id != -1;
                  })
                "
              >
                <b-table-column field="id" label="ID" numeric v-slot="props">
                  {{ props.row.id }}
                </b-table-column>
                <b-table-column field="name" label="Name" v-slot="props">
                  {{ props.row.name }}
                </b-table-column>
                <b-table-column field="description" label="Description" v-slot="props">
                  {{ props.row.description }}
                </b-table-column>
                <b-table-column field="actions" label="Actions" v-slot="props">
                  <b-button type="is-danger" icon-right="trash" @click="deletePreset(props.row.id)" />
                </b-table-column>

                <template #empty> No presets found for this module </template>
              </b-table>

              <b-button type="is-warning" @click="isNewPresetActive = true">New Preset</b-button>
            </b-tab-item>
          </b-tabs>

          <b-modal :active.sync="isNewSettingActive" has-modal-card trap-focus :destroy-on-hide="false" aria-role="dialog" aria-modal>
            <new-setting @submitted="AddSetting" :item="this.formProps"></new-setting>
          </b-modal>

          <b-modal :active.sync="isNewTTSActive" props.languages="this.languages" has-modal-card trap-focus :destroy-on-hide="false" aria-role="dialog" aria-modal>
            <new-tts @submitted="AddTTS" :languages="this.languages" :item="this.formProps"></new-tts>
          </b-modal>

          <b-modal :active.sync="isNewOutputActive" has-modal-card trap-focus :destroy-on-hide="false" aria-role="dialog" aria-modal>
            <new-output @submitted="AddOutput" :item="this.formProps"></new-output>
          </b-modal>

          <b-modal :active.sync="isNewPresetActive" has-modal-card trap-focus :destroy-on-hide="true" aria-role="dialog" aria-modal>
            <new-preset @submitted="AddPreset" :item="this.formProps"></new-preset>
          </b-modal>
        </div>
      </div>
      <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false"></b-loading>
    </div>
  </div>
</template>

<script>
const NewOutput = {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  template: `
              <form @submit.prevent="">
                  <div class="modal-card">
                      <header class="modal-card-head">
                          <p class="modal-card-title">Add Output</p>
                      </header>
                      <section class="modal-card-body">
                          <b-field label="Output Name">
                              <b-input type="text" v-model="item.name"></b-input>
                          </b-field>
                      </section>
                      <footer class="modal-card-foot">
                          <button class="button is-primary" @click="$emit('submitted')">Submit</button>
                          <button class="button" type="button" @click="$parent.close()">Cancel</button>
                      </footer>
                  </div>
              </form>
              `,
};
const NewTts = {
  props: {
    languages: {
      type: Array,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  mounted() {},
  template: `
              <form @submit.prevent="">
                  <div class="modal-card">
                      <header class="modal-card-head">
                          <p class="modal-card-title">Add TTS</p>
                      </header>
                      <section class="modal-card-body">
                          <b-field label="TTS tag">
                              <b-input type="text" v-model="item.tag"></b-input>
                          </b-field>
                          <b-field label="Content">
                              <b-input type="text" v-model="item.content"></b-input>
                          </b-field>
                          <b-field label="Language">
                              <b-select placeholder="Select a Language" v-model="item.language_id">
                                  <option
                                      v-for="lang in languages"
                                      :value="lang.language_id"
                                      :key="lang.language_id">{{lang.name}} - {{lang.code}}
                                  </option>
                              </b-select>
                          </b-field>
                          <b-field label="Has Beep">
                              <b-checkbox v-model="item.beep">

                              </b-checkbox>
                          </b-field>
                      </section>
                      <footer class="modal-card-foot">
                        <button class="button is-primary" @click="$emit('submitted')">Submit</button>
                        <button class="button" type="button" @click="$parent.close()">Cancel</button>
                      </footer>
                  </div>
              </form>
              `,
};
const NewSetting = {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  template: `
              <form @submit.prevent="">
                  <div class="modal-card">
                      <header class="modal-card-head">
                          <p class="modal-card-title">Add Setting</p>
                      </header>
                      <section class="modal-card-body">
                          <b-field label="Setting Name">
                              <b-input type="text" v-model="item.settings_name"></b-input>
                          </b-field>
                          <b-field label="Setting Value">
                              <b-input type="text" v-model="item.settings_value"></b-input>
                          </b-field>
                      </section>
                      <footer class="modal-card-foot">
                          <button class="button is-primary" @click="$emit('submitted')" >Submit</button>
                          <button class="button" type="button" @click="$parent.close()">Cancel</button>
                      </footer>
                  </div>
              </form>
              `,
};
const NewPreset = {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  template: `
              <form @submit.prevent="">
                  <div class="modal-card">
                      <header class="modal-card-head">
                          <p class="modal-card-title">New Preset</p>
                      </header>
                      <section class="modal-card-body">
                          <b-field label="Preset Name">
                              <b-input type="text" v-model="item.name"></b-input>
                          </b-field>
                          <b-field label="Preset Description">
                              <b-input type="text" v-model="item.description"></b-input>
                          </b-field>
                      </section>
                      <footer class="modal-card-foot">
                          <button class="button is-primary" @click="$emit('submitted')" >Submit</button>
                          <button class="button" type="button" @click="$parent.close()">Cancel</button>
                      </footer>
                  </div>
              </form>
              `,
};

import ConditionsModal from "./EditModule/ConditionsModal";
import NotificationHelper from "@/mixins/SendNotification";
const axios = require("axios");
export default {
  components: {
    NewOutput,
    NewSetting,
    NewTts,
    NewPreset,
  },
  mixins: [NotificationHelper],
  data: function () {
    return {
      moduleId: -1,
      moduleDetails: {},
      outputs: [],
      ttsArray: [],
      settings: [],
      settingsCopy: [],
      activeTab: 0,
      activeTabTTS: 0,
      isNewSettingActive: false,
      isNewOutputActive: false,
      isNewTTSActive: false,
      isNewPresetActive: false,
      languages: [],
      formProps: {},
      isLoading: false,
      newApiUrl: "https://api.jeak.co.uk",
      settingsTypes: [],
      presets: [],
      selectedPreset: -1,
      selectedPresetSettings: {},
      selectedPresetTTS: {},
    };
  },
  methods: {
    Load: async function () {
      try {
        this.isLoading = true;
        await this.LoadModule();
        await this.LoadOutputs();
        await this.LoadTTS();
        await this.LoadSettings();
        await this.LoadSettingsTypes();
        await this.LoadPresets();
        this.isLoading = false;
      } catch (e) {
        console.error(e);
      }
    },
    async LoadPresets() {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      this.selectedPreset = -1;
      this.presets = [];
      this.presets = this.presets.concat(
        [{ id: -1, name: "Default", description: "", module_id: this.moduleId }],
        (await axios.get(this.newApiUrl + `/modules/${this.moduleId}/presets`, config)).data
      );
    },
    async UpdatePreset(presetId) {
      if (presetId == -1) {
        this.selectedPresetSettings = {};
        return;
      }
      this.isLoading = true;
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      const presetSettingsRes = await axios.get(this.newApiUrl + `/modules/${this.moduleId}/presets/${presetId}/settings`, config);

      const presetSettingObj = {};

      for (const setting of this.settings) {
        let found = false;
        for (const presetSetting of presetSettingsRes.data) {
          if (presetSetting.setting_id == setting.settings_id) {
            found = true;
            presetSetting.is_default = false;
            presetSetting.default_value = setting.settings_value;
            presetSettingObj[presetSetting.setting_id] = presetSetting;
          }
        }

        if (!found) {
          presetSettingObj[setting.settings_id] = {
            id: -1,
            preset_id: presetId,
            setting_id: setting.settings_id,
            setting_value: setting.settings_value,
            is_default: true,
            default_value: setting.settings_value,
          };
        }
      }

      this.selectedPresetSettings = presetSettingObj;

      const presetTTSRes = await axios.get(this.newApiUrl + `/modules/${this.moduleId}/presets/${presetId}/tts`, config);

      const presetTTSObj = {};
      for (const language of this.ttsArray) {
        for (const tts of language.ttsContent) {
          let found = false;
          for (const presetTTS of presetTTSRes.data) {
            if (presetTTS.tts_id == tts.tts_id) {
              found = true;
              presetTTS.is_default = false;
              presetTTS.default_value = tts.content;
              presetTTSObj[presetTTS.tts_id] = presetTTS;
            }
          }

          if (!found) {
            presetTTSObj[tts.tts_id] = {
              id: -1,
              preset_id: presetId,
              tts_id: tts.tts_id,
              tts_value: tts.content,
              is_default: true,
              default_value: tts.content,
            };
          }
        }
      }
      this.selectedPresetTTS = presetTTSObj;
      this.isLoading = false;
    },
    async savePresetSetting(setting) {
      this.isLoading = true;
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      if (setting.id == -1 && !setting.is_default) {
        //--- New Setting
        await axios.post(this.newApiUrl + `/modules/${this.moduleId}/presets/${this.selectedPreset}/settings`, setting, config);
      } else if (setting.id != -1 && setting.is_default) {
        //--- Setting Deleted
        await axios.delete(this.newApiUrl + `/modules/${this.moduleId}/presets/${this.selectedPreset}/settings/${setting.setting_id}`, config);
      } else if (setting.id == -1 && setting.is_default) {
        //--- Nothing has changed
      } else {
        //--- Update Setting
        await axios.put(this.newApiUrl + `/modules/${this.moduleId}/presets/${this.selectedPreset}/settings/${setting.setting_id}`, setting, config);
      }

      await this.UpdatePreset(this.selectedPreset);
      this.isLoading = false;
    },
    async savePresetTTS(tts) {
      this.isLoading = true;
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      if (tts.id == -1 && !tts.is_default) {
        //--- New TTS
        await axios.post(this.newApiUrl + `/modules/${this.moduleId}/presets/${this.selectedPreset}/tts`, tts, config);
      } else if (tts.id != -1 && tts.is_default) {
        //--- TTS Deleted
        await axios.delete(this.newApiUrl + `/modules/${this.moduleId}/presets/${this.selectedPreset}/tts/${tts.tts_id}`, config);
      } else if (tts.id == -1 && tts.is_default) {
        //--- Nothing has changed
      } else {
        //--- Update TTS
        await axios.put(this.newApiUrl + `/modules/${this.moduleId}/presets/${this.selectedPreset}/tts/${tts.tts_id}`, tts, config);
      }
      await this.UpdatePreset(this.selectedPreset);
      this.isLoading = false;
    },
    async deletePreset(presetId) {
      this.isLoading = true;
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      await axios.delete(this.newApiUrl + `/modules/${this.moduleId}/presets/${presetId}`, config);
      await this.LoadPresets();
      this.isLoading = false;
    },
    goBack() {
      this.$router.push("modules");
    },
    async saveOutput(output) {
      this.isLoading = true;
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      try {
        await axios.put(this.newApiUrl + `/modules/${this.moduleId}/outputs/${output.id}`, output, config);
        this.SendNotification(`${this.$route.params.name} updated Output-${output.id} from ${this.moduleDetails.module_name}\n\nNew Name: ${output.name}`, "warning");
        await this.LoadOutputs();
        this.isLoading = false;
      } catch (e) {
        this.HandleCatch(e);
      }
    },
    async saveTTS(tts) {
      this.isLoading = true;
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      if (!tts.beep) tts.beep = false;
      try {
        await axios.put(this.newApiUrl + `/modules/${this.moduleId}/defaults/tts/${tts.tts_id}`, tts, config);

        this.SendNotification(`${this.$route.params.name} updated TTS-${tts.tag} from ${this.moduleDetails.module_name}\n\nNew Content: ${tts.content}`, "warning");
        await this.LoadTTS();
        this.isLoading = false;
      } catch (e) {
        this.HandleCatch(e);
      }
    },
    async updateModule() {
      this.isLoading = true;

      this.moduleDetails.conditions = {
        condition_type: this.conditionType,
        conditions: this.conditions,
      };

      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      try {
        await axios.put(this.newApiUrl + `/modules/${this.moduleId}`, this.moduleDetails, config);
        this.$buefy.toast.open({
          message: "Great Success",
          type: "is-success",
        });
        this.SendNotification(`${this.$route.params.name} updated module ${this.moduleDetails.module_name}`, "error");
        await this.LoadModule();
        this.isLoading = false;
      } catch (e) {
        this.HandleCatch(e);
      }
    },
    async deleteTTS(id) {
      this.isLoading = true;
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      try {
        await axios.delete(this.newApiUrl + `/modules/${this.moduleId}/defaults/tts/${id}`, config);

        this.SendNotification(`${this.$route.params.name} deleted TTS from ${this.moduleDetails.module_name}`, "error");
        await this.LoadTTS();
        this.isLoading = false;
      } catch (e) {
        this.HandleCatch(e);
      }
    },
    async deleteSetting(settingId) {
      this.isLoading = true;
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      let setting = this.settings.filter((item) => {
        return item.settings_id == settingId;
      });
      try {
        await axios.delete(this.newApiUrl + `/modules/${this.moduleId}/defaults/settings/${settingId}`, config);
        this.$buefy.toast.open({
          message: "Great Success",
          type: "is-success",
        });
        this.SendNotification(`${this.$route.params.name} deleted setting ${setting[0].settings_name} from ${this.moduleDetails.module_name}`, "error");
        await this.LoadSettings();
        this.isLoading = false;
      } catch (e) {
        this.HandleCatch(e);
      }
    },
    async deleteOutput(outputId) {
      this.isLoading = true;
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      try {
        await axios.delete(this.newApiUrl + `/modules/${this.moduleId}/outputs/${outputId}`, config);
        this.$buefy.toast.open({
          message: "Great Success",
          type: "is-success",
        });
        await this.LoadOutputs();
        this.isLoading = false;
      } catch (e) {
        this.HandleCatch(e);
      }
    },
    async AddPreset() {
      this.isLoading = true;
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      this.isNewPresetActive = false;

      try {
        await axios.post(this.newApiUrl + `/modules/${this.moduleId}/presets`, this.formProps, config);
        this.$buefy.toast.open({
          message: "Great Success",
          type: "is-success",
        });
        await this.LoadPresets();
        this.formProps = {};
        this.isLoading = false;
      } catch (e) {
        this.HandleCatch(e);
      }
    },
    async AddSetting() {
      this.isLoading = true;
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      this.isNewSettingActive = false;
      try {
        await axios.post(this.newApiUrl + `/modules/${this.moduleId}/defaults/settings`, this.formProps, config);
        this.$buefy.toast.open({
          message: "Great Success",
          type: "is-success",
        });
        await this.LoadSettings();
        this.formProps = {};
        this.isLoading = false;
      } catch (e) {
        this.HandleCatch(e);
      }
    },
    async AddOutput() {
      this.isLoading = true;
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      this.isNewOutputActive = false;
      try {
        await axios.post(this.newApiUrl + `/modules/${this.moduleId}/outputs`, this.formProps, config);
        this.$buefy.toast.open({
          message: "Great Success",
          type: "is-success",
        });
        await this.LoadOutputs();
        this.formProps = {};
        this.isLoading = false;
      } catch (e) {
        this.HandleCatch(e);
      }
    },
    async AddTTS() {
      this.isLoading = true;
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      this.isNewTTSActive = false;
      if (!this.formProps.beep) this.formProps.beep = false;

      try {
        await axios.post(this.newApiUrl + `/modules/${this.moduleId}/defaults/tts`, this.formProps, config);
        this.$buefy.toast.open({
          message: "Great Success",
          type: "is-success",
        });
        await this.LoadTTS();
        this.formProps = {};
        this.isLoading = false;
      } catch (e) {
        this.HandleCatch(e);
      }
    },
    async LoadTTS() {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      this.languages = (await axios.get(this.newApiUrl + `/languages`, config)).data;
      var bufferedThis = this;
      this.ttsArray = [];
      for (const lang of this.languages) {
        let tts = (await axios.get(this.newApiUrl + `/modules/${this.moduleId}/defaults/tts?languageId=${lang.language_id}`, config)).data;

        bufferedThis.ttsArray.push({
          code: lang.code,
          name: lang.name,
          language_id: lang.language_id,
          ttsContent: tts,
        });
      }
    },
    async LoadSettings() {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };

      const settingsRes = await axios.get(this.newApiUrl + `/modules/${this.moduleId}/defaults/settings`, config);

      this.settings = settingsRes.data;
      const copy = [];
      for (const setting of this.settings) {
        copy.push(Object.assign({}, setting));
      }
      this.settingsCopy = copy; //This is used to detect changes
    },
    async LoadSettingsTypes() {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      this.settingsTypes = [{ id: null, type: "None", values: "" }];
      const types = (await axios.get(this.newApiUrl + `/modules/settings/types`, config)).data;
      this.settingsTypes = this.settingsTypes.concat(types);
    },
    async LoadOutputs() {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      this.outputs = (await axios.get(this.newApiUrl + `/modules/${this.moduleId}/outputs`, config)).data;
    },
    async LoadModule() {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      this.moduleDetails = (await axios.get(this.newApiUrl + `/modules/${this.moduleId}`, config)).data;

      if (this.moduleDetails.conditions) {
        this.conditions = this.moduleDetails.conditions.conditions;
        this.conditionType = this.moduleDetails.conditions.condition_type;
      }
    },
    HasGroup(groups = []) {
      if (!(this.$route && this.$route.params && Array.isArray(this.$route.params.groups))) return false;
      const userGroups = this.$route.params.groups.map((group) => String(group).toLowerCase());
      for (const group of groups) {
        if (userGroups.includes(String(group).toLowerCase())) return true;
      }

      return false;
    },
    OpenConditionsModal(setting, type) {
      const modal = this.$buefy.modal.open({
        props: {
          setting: setting,
          settings: this.settings,
        },
        parent: this,
        component: ConditionsModal,
        hasModalCard: true,
        trapFocus: true,
        events: {
          submitted: (condition, value) => {
            if (type == "setting") {
              const setting = value;
              for (const settingLoop of this.settings) {
                if (settingLoop.settings_id == setting.settings_id) {
                  const settingCopy = Object.assign({}, settingLoop);
                  settingLoop.conditions = condition;
                  settingLoop.edited = true;
                  settingLoop.oldVersion = settingCopy;
                  modal.close();
                  break;
                }
              }
            } else {
              const tts = value;
              for (const languageLoop of this.ttsArray) {
                for (const ttsLoop of languageLoop.ttsContent) {
                  if (ttsLoop.tts_id == tts.tts_id) {
                    ttsLoop.conditions = condition;
                    modal.close();
                    break;
                  }
                }
              }
            }
          },
        },
      });
    },
    async HandleCatch(e) {
      this.$buefy.toast.open({
        message: "An error occurred! If this persists, please contact support",
        type: "is-danger",
      });
      console.error(e);
      this.isLoading = false;
    },
    async GetAxios() {
      console.log(this.newApiUrl);
      const token = await this.$cognitoAuth.getIdToken();
      const instance = axios.create({
        baseURL: this.newApiUrl,
        headers: { Authorization: "Bearer " + token },
      });

      return instance;
    },
    async SaveSettings() {
      this.isLoading = true;
      const promiseArr = [];
      const axiosInst = await this.GetAxios();
      console.log(axiosInst);
      for (const setting of this.settings) {
        if (setting.edited) {
          const notificationPromise = this.SendNotification(
            `${this.$route.params.name} updated Setting-${setting.settings_name} from ${this.moduleDetails.module_name}\n\nold Content: ${setting.oldVersion.settings_value}\n\nNew Content: ${setting.settings_value}`,
            "warning"
          );
          promiseArr.push(notificationPromise);

          delete setting.oldVersion;
          delete setting.edited;
          const settingPromise = axiosInst.put(`/modules/${this.moduleId}/defaults/settings/${setting.settings_id}`, setting);

          promiseArr.push(settingPromise);
        }
      }

      await Promise.all(promiseArr);
      this.isLoading = false;

      this.$buefy.toast.open({
        message: "Settings Saved Successfully",
        type: "is-success",
      });
    },
  },
  async beforeMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const module = urlParams.get("module");
    this.moduleId = module;
    await this.Load();
  },
  watch: {
    settings: {
      deep: true,
      handler(newSettings) {
        if (this.isLoading) return;
        const paramsToCheck = ["description", "display_order", "formatted_name", "hidden", "settings_type_id", "settings_value"];
        for (const newSetting of newSettings) {
          for (const oldSetting of this.settingsCopy) {
            if (newSetting.settings_id == oldSetting.settings_id) {
              let edited = false;

              for (const paramToCheck of paramsToCheck) {
                if (edited) break;
                if (newSetting[paramToCheck] != oldSetting[paramToCheck]) {
                  edited = true;
                }
              }

              if (edited) {
                newSetting.oldVersion = oldSetting;
                newSetting.edited = true;
              }
            }
          }
        }
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
